import { Injectable, signal } from '@angular/core';
import { HttpErrorKind } from '@core/models/http-error.model';

/** Conserve un seul message global ; une erreur de session reste prioritaire. */
@Injectable({ providedIn: 'root' })
export class HttpErrorService {
	readonly notice = signal<HttpErrorKind | null>(null);
	readonly reconnectConfirmation = signal(false);

	report(kind: HttpErrorKind): void {
		if (this.notice() === 'session' || this.notice() === 'csrf') return;
		this.notice.set(kind);
	}

	dismiss(): void {
		this.notice.set(null);
		this.reconnectConfirmation.set(false);
	}

	requestReconnect(): void {
		this.reconnectConfirmation.set(true);
	}

	cancelReconnect(): void {
		this.reconnectConfirmation.set(false);
	}

	reconnect(): void {
		window.location.assign(new URL('login', document.baseURI).href);
	}
}
